module.exports = require('./head');



//////////////////
// WEBPACK FOOTER
// ./~/lodash/first.js
// module id = 526
// module chunks = 0